exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-details-wrapper {\n  background: #4285F4;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Private Projects/random-ride/RandomRide/src/app/point-details/point-details.component.scss
// module id = ../../../../../src/app/point-details/point-details.component.scss
// module chunks = main